<template>
  <div class="login-container">
    <el-card class="login-card">
      <div slot="header" style="text-align: center; display: flex; align-items: center; justify-content: center;">
        <img src="@/images/ryzs_logo.png" style="height: 40px; margin-right: 10px;" alt="logo" />
        <span style="font-size: 20px; font-weight: bold;">如易智算后台管理</span>
      </div>
      <el-form :model="loginForm" ref="loginForm" label-width="0">
        <el-form-item>
          <el-input v-model="loginForm.username" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input type="password" v-model="loginForm.password" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="width: 100%;" @click="handleLogin">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    async handleLogin() {
      try {
        const res = await api.login(this.loginForm);
        if (res && res.access_token) {
          api.setToken(res.access_token);
        }
        this.$router.push('/dashboard');
      } catch (e) {
        console.error(e);
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f2f5;
}
.login-card {
  width: 400px;
}
</style>
